import { inject, Injectable } from '@angular/core';
import { LogService } from '@app/core/services/log.service';
import { CLIENT_KEY, GOOGLE_MERCHANT_API_VERSION_KEY, GOOGLE_MERCHANT_API_VERSION_VALUE, GOOGLE_PRODUCT_FEED_CLIENT_VALUE } from '@app/exports/models/constants/export-http-body.constants';
import { ExportInterface } from '@app/exports/models/interfaces/export.interface';

@Injectable({
    providedIn: 'root'
})
export class ExportUtilitiesService {

    private readonly logService: LogService = inject(LogService);

    public parseWebhookHTTPBody(e: Partial<ExportInterface>): Record<string, string | number | boolean> {
        // get protocol info > http body
        let body = e.protocol_info?.http_body;

        // must have http body defined
        if (!body) {
            return null;
        }

        // unquoted feedonomics::data_url::json can break JSON.parse
        // https://feedonomics.atlassian.net/browse/FP-9667
        body = body.replace(/"?feedonomics::data_url::json"?/g, '"feedonomics::data_url::json"');

        try {
            return JSON.parse(body) as Record<string, string | number | boolean>;
        } catch (error) {
            this.logService.warn('[exportUtilitiesService:parseWebhookHTTPBody] Failed to json parse webhook http body:', error);
            return null;
        }
    }

    public getWebhookClient(e: ExportInterface): string {

        const parsed: Record<string, string | number | boolean> = this.parseWebhookHTTPBody(e);

        if (typeof (parsed?.client) !== 'string') {
            return null;
        }

        return parsed.client;
    }

    // Check whether this export uses the Merchant API
    public doesExportUseMerchantAPI(e: ExportInterface): boolean {
        const parsed: Record<string, string | number | boolean> = this.parseWebhookHTTPBody(e);

        // Is the client correct?
        if (typeof (parsed?.[CLIENT_KEY]) !== 'string' || parsed[CLIENT_KEY] !== GOOGLE_PRODUCT_FEED_CLIENT_VALUE) {
            return false;
        }

        // Is the API version correct?
        if (typeof (parsed?.[GOOGLE_MERCHANT_API_VERSION_KEY]) !== 'string' || parsed[GOOGLE_MERCHANT_API_VERSION_KEY] !== GOOGLE_MERCHANT_API_VERSION_VALUE) {
            return false;
        }

        return true;
    }
}
